// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_Pi","wrapperDark":"e_Qi","wrapperLight":"e_Ri"};